export default __webpack_public_path__ + "static/media/provesional_restoration_upper_26_4@2x.91a021dd.png";